import React, { useState } from 'react';
import { Button, ListGroup } from 'react-bootstrap';
import AddressModal from './AddAddressModal';
import DeleteConfirmationModal from './Global/DeleteConfirmationModal';
import { updateClientAddress, deleteClientAddress, logError } from '../api'; // Importamos las funciones

const ClientAddressList = ({ client, setClient }) => {
    const [showAddressModal, setShowAddressModal] = useState(false);
    const [editingAddress, setEditingAddress] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [addressToDelete, setAddressToDelete] = useState(null);

    const handleAddressEdit = (address) => {
        setEditingAddress(address);
        setShowAddressModal(true);
    };

    const handleAddressModalClose = () => {
        setShowAddressModal(false);
        setEditingAddress(null);
    };

    const handleAddressSave = (address) => {
        setClient((prevState) => {
            // Check if the address already exists (for editing)
            const existingAddressIndex = prevState.addresses.findIndex(addr => addr.id === address.id);

            if (existingAddressIndex !== -1) {
                // If it exists, update it
                const updatedAddresses = [...prevState.addresses];
                updatedAddresses[existingAddressIndex] = address;
                return {
                    ...prevState,
                    addresses: updatedAddresses,
                };
            } else {
                // If it's a new address, add it to the array
                return {
                    ...prevState,
                    addresses: [...prevState.addresses, address],
                };
            }
        });
        setShowAddressModal(false);
        setEditingAddress(null);
    };

    const handleDeleteAddress = (address) => {
        setAddressToDelete(address);
        setShowDeleteModal(true);
    };

    const handleDeleteConfirm = () => {
        if (!addressToDelete) return;

        deleteClientAddress(addressToDelete.id)
            .then(() => {
                setClient((prevState) => ({
                    ...prevState,
                    addresses: prevState.addresses.filter(
                        (address) => address.id !== addressToDelete.id
                    ),
                }));
                setShowDeleteModal(false); // Cerrar el modal si la eliminación fue exitosa
                setAddressToDelete(null);   // Limpiar la dirección a eliminar
            })
            .catch((error) => {
                console.error('Error al eliminar la dirección:', error);
                logError(error);
                setShowDeleteModal(false); // También cerramos el modal si hay error
                setAddressToDelete(null);   // Limpiar la dirección a eliminar en caso de error
            });
    };

    const handleDeleteCancel = () => {
        setShowDeleteModal(false);
        setAddressToDelete(null); // Limpiar la dirección seleccionada para eliminar
    };

    const handleSetDefaultAddress = (addressId) => {
        const updatedAddresses = client.addresses.map((address) => ({
            ...address,
            isDefault: address.id === addressId ? true : false,
        }));

        const addressToUpdate = updatedAddresses.find((addr) => addr.id === addressId);

        updateClientAddress(addressId, {
            ...addressToUpdate,
            isDefault: true,
        })
            .then(() => {
                setClient((prevState) => ({
                    ...prevState,
                    addresses: updatedAddresses,
                }));
            })
            .catch((error) => {
                console.error('Error al establecer la dirección por defecto:', error);
                logError(error);
            });
    };

    return (
        <div>
            <h3>Direcciones</h3>
            <ListGroup>
                {client.addresses.map((address) => (
                    <ListGroup.Item key={address.id}>
                        {address.address}, {address.city}{address.district ? `, ${address.district}` : ''}, {address.state} {address.zipCode}, {address.country}
                        <Button variant="link" onClick={() => handleAddressEdit(address)}>
                            Editar
                        </Button>
                        <Button variant="danger" onClick={() => handleDeleteAddress(address)}>
                            Eliminar
                        </Button>
                        <Button
                            variant={address.isDefault ? 'success' : 'outline-secondary'}
                            onClick={() => handleSetDefaultAddress(address.id)}
                        >
                            {address.isDefault ? 'Por defecto' : 'Establecer como por defecto'}
                        </Button>
                    </ListGroup.Item>
                ))}
            </ListGroup>

            <Button variant="primary" onClick={() => setShowAddressModal(true)}>
                Agregar nueva dirección
            </Button>

            {/* Modal para agregar o editar una dirección */}
            <AddressModal
                show={showAddressModal}
                handleClose={handleAddressModalClose}
                handleSave={handleAddressSave}
                address={editingAddress}
                clientId={client.id}
            />

            {/* Modal de confirmación para eliminar dirección */}
            <DeleteConfirmationModal
                show={showDeleteModal}
                onHide={handleDeleteCancel}
                onConfirm={handleDeleteConfirm}
                message={`¿Estás seguro de que quieres eliminar la dirección: ${addressToDelete ? addressToDelete.address : ''}?`}
            />
        </div>
    );
};

export default ClientAddressList;
